module.exports = __webpack_public_path__ + "static/bailey-2a792c812c51d41948abc2cade5a172f.png";